function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.29,
    y: 76.16,
    width: 291.79,
    height: 136.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 76.16,
    width: 294.13,
    height: 136.52,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.29,
    y: 212.68,
    width: 291.79,
    height: 6.96,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.66,
    y: 212.68,
    width: 294.13,
    height: 6.96,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.3,
    y: 3.51,
    width: 124.21,
    height: 281.82,
    transform: "translate(394.83 -105.98) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.73 206.53 156.86 82.32 183.59 82.32 166.46 206.53 139.73 206.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.34,200.4a.44.44,0,0,1-.44-.44V86.32a.44.44,0,0,1,.44-.44.44.44,0,0,1,.44.44V200A.43.43,0,0,1,112.34,200.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.2 206.53 189.33 82.32 199.75 82.32 182.62 206.53 172.2 206.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.82,
    y: 144.03,
    width: 124.21,
    height: 0.78,
    transform: "translate(535.35 -246.5) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.92 91.6 107.14 91.6 106.57 84.71 398.36 84.71 398.92 91.6",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.92 102.89 107.14 102.89 106.57 96 398.36 96 398.92 102.89",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.92 114.19 107.14 114.19 106.57 107.3 398.36 107.3 398.92 114.19",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.92 125.48 107.14 125.48 106.57 118.59 398.36 118.59 398.92 125.48",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.92 136.78 107.14 136.78 106.57 129.89 398.36 129.89 398.92 136.78",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.92 148.07 107.14 148.07 106.57 141.18 398.36 141.18 398.92 148.07",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.47,
    y: 247,
    width: 44.53,
    height: 135.4,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.11 382.4 439 382.4 439 363.71 414.64 363.71 427.11 382.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.06,
    y: 247,
    width: 44.53,
    height: 135.4,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.21,
    y: 247,
    width: 131.79,
    height: 128.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.1 382.4 307.21 382.4 307.21 363.71 331.57 363.71 319.1 382.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.43,
    y: 295.06,
    width: 113.34,
    height: 32.27,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.43,
    y: 334.23,
    width: 113.34,
    height: 32.27,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.24,292.26H412a0,0,0,0,1,0,0v1.57a4.67,4.67,0,0,1-4.67,4.67H338.92a4.67,4.67,0,0,1-4.67-4.67v-1.57A0,0,0,0,1,334.24,292.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.43,
    y: 255.88,
    width: 113.34,
    height: 32.27,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.24,253.09H412a0,0,0,0,1,0,0v1.57a4.67,4.67,0,0,1-4.67,4.67H338.92a4.67,4.67,0,0,1-4.67-4.67v-1.57A0,0,0,0,1,334.24,253.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.24,331.43H412a0,0,0,0,1,0,0V333a4.67,4.67,0,0,1-4.67,4.67H338.92a4.67,4.67,0,0,1-4.67-4.67v-1.57A0,0,0,0,1,334.24,331.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.42,275.87c2.48-7.13,22,2.56,30,14.36,5.29,7.86,8.52,16.25,10,27.52-.18-12.86-.38-26.67-.58-39.71-1.61-3.25-5.28-10.75-7.91-16.69-8.8-19.82-29.72-27.2-37-39.71-9.47-16.4-9.41-41-1.35-49.86,7-7.72,30.2,44.43,32.82,50.26,9,20,11.6,34.91,13.28,49.32-.19-12.25-.37-23.49-.52-32.17-.49-28.3-1.11-37.4-1.39-40.2-1-1.37-2.11-3-2.78-3.82-5.61-7.23-18.07-15.83-24.29-26.34-9.09-15.34-7.62-33.7-1.25-40.54C69.17,121.14,81,138,87.21,154.78s3.58,32.76,5.34,46.67c.37,2.72.74,13.08,1.1,27.45,1.9-15.46,5.68-25.82,12.68-35.47,8.62-11.87,16.06-26.32,23.16-24.45s3.28,21-2.34,34.42c-5,11.95-29.68,23.88-33.32,33.49.43,19.48.81,44.15,1.09,67.12,1.94-11.87.6-12.86,8.58-31,4.74-10.8,24.17-24.11,26.49-16.69s-1.21,21.44-8.54,31.26c-5.92,7.93-19,7.92-22.09,12.83-.71,1.15-3,5.55-4.39,8.07.31,28.05.46,52.8.3,61.24l-1.28.09c.07-2.18-.09-16.45-.34-35.33-3.19-10-24.65-15.9-31.28-26.35C55.43,297.17,50.44,284.41,53.42,275.87Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,382.4h41.2a4.74,4.74,0,0,0,4.64-3.79l2.92-14.42H66L69,378.61A4.74,4.74,0,0,0,73.6,382.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.86,369.78h58.68a2.77,2.77,0,0,0,2.75-2.46l1.2-10.66a2.77,2.77,0,0,0-2.75-3.07H63.66a2.77,2.77,0,0,0-2.75,3.07l1.2,10.66A2.77,2.77,0,0,0,64.86,369.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.63,
    y: 317.62,
    width: 35.21,
    height: 64.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.58 382.4 149.69 382.4 137.3 294.5 255.19 294.5 267.58 382.4",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.78 382.4 154.37 382.4 141.99 294.5 272.39 294.5 284.78 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.13 368.66 156.7 308.24 259.63 308.24 270.06 368.66 167.13 368.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.36 368.66 176.38 308.24 187.35 308.24 222.34 368.66 211.36 368.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.99 368.66 192 308.24 210.72 308.24 245.7 368.66 226.99 368.66",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Warning--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.27,221.53a.43.43,0,0,1-.43-.39l-2.22-26.7A.42.42,0,0,1,75,194a.43.43,0,0,1,.46.39l2.22,26.7a.43.43,0,0,1-.39.46Z",
    style: {
      fill: "#571AC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,237.39a.43.43,0,0,1-.43-.39l-.67-8.08a.42.42,0,0,1,.39-.46.42.42,0,0,1,.46.39l.67,8.08a.43.43,0,0,1-.39.46Z",
    style: {
      fill: "#571AC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,313.37H97.08a10.63,10.63,0,0,1-10.37-9.58L75.08,164a8.7,8.7,0,0,1,8.78-9.58H290.33A10.64,10.64,0,0,1,300.71,164l11.63,139.77A8.71,8.71,0,0,1,303.56,313.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,313.77H97.08a11,11,0,0,1-10.77-9.94L74.68,164.05A9.2,9.2,0,0,1,77.05,157,9.1,9.1,0,0,1,83.86,154H290.33a11,11,0,0,1,10.78,10l11.62,139.77a9.09,9.09,0,0,1-9.17,10ZM83.86,154.84A8.3,8.3,0,0,0,75.47,164L87.1,303.76a10.22,10.22,0,0,0,10,9.21H303.56a8.3,8.3,0,0,0,8.38-9.14L300.31,164.05a10.21,10.21,0,0,0-10-9.21Z",
    style: {
      fill: "#571AC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.33,154.44H83.86A8.7,8.7,0,0,0,75.08,164H300.71A10.64,10.64,0,0,0,290.33,154.44Z",
    style: {
      fill: "#571AC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.69,159.23a1.87,1.87,0,0,1-1.89,2.07,2.3,2.3,0,0,1-2.24-2.07,1.88,1.88,0,0,1,1.89-2.07A2.28,2.28,0,0,1,88.69,159.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09,159.23a1.87,1.87,0,0,1-1.89,2.07A2.3,2.3,0,0,1,93,159.23a1.88,1.88,0,0,1,1.89-2.07A2.28,2.28,0,0,1,97.09,159.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.49,159.23a1.87,1.87,0,0,1-1.89,2.07,2.3,2.3,0,0,1-2.24-2.07,1.88,1.88,0,0,1,1.89-2.07A2.28,2.28,0,0,1,105.49,159.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.64,295.05H112a8.45,8.45,0,0,1-8.25-7.61L95.59,190a6.92,6.92,0,0,1,7-7.61H276.26a8.45,8.45,0,0,1,8.25,7.61l8.11,97.49A6.92,6.92,0,0,1,285.64,295.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.92,199.41l-53.8,64.78a15.39,15.39,0,0,0,8.58,24.88L274,307.94a15.39,15.39,0,0,0,17.55-20.76l-33.47-83.66A15.39,15.39,0,0,0,231.92,199.41Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.16,208.49,93.42,259A9.72,9.72,0,0,0,103.48,272l54.73-5.37a9.72,9.72,0,0,0,6.65-15.74l-36-45.1A9.72,9.72,0,0,0,112.16,208.49Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48,183.1l-50.3,73a16.18,16.18,0,0,0,11.2,25.22l92.46,12.31a16.18,16.18,0,0,0,16.64-23.21l-42.16-85.34A16.18,16.18,0,0,0,250.48,183.1Z",
    style: {
      fill: "#571AC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.57,274.8a10.22,10.22,0,0,1-7.82-5.67,9,9,0,0,1,.47-9.2l50.43-73.22a8.48,8.48,0,0,1,8.29-3.52,10.2,10.2,0,0,1,7.82,5.67L315,274.41a9,9,0,0,1-.47,9.2,8.47,8.47,0,0,1-8.29,3.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.65,209.07l5.89.78a7.57,7.57,0,0,1,6.51,7.7l-.4,7.68a5.7,5.7,0,0,1-.09.83l-4.19,23.15a6.23,6.23,0,0,1-7.11,5h0a7.61,7.61,0,0,1-6.51-6.87l-1.69-23.92a5.77,5.77,0,0,1,0-.83l.39-7.69A6.21,6.21,0,0,1,260.65,209.07Zm-.47,51.56,1.6.21a6.78,6.78,0,0,1,5.83,6.89h0a5.57,5.57,0,0,1-6.45,5.25l-1.6-.22a6.77,6.77,0,0,1-5.83-6.88h0A5.56,5.56,0,0,1,260.18,260.63Z",
    style: {
      fill: "#571AC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,194.26l-13.81,52.37a9.72,9.72,0,0,0,11.27,12l53.57-10.45A9.72,9.72,0,0,0,187.72,232L148,190.05A9.73,9.73,0,0,0,131.5,194.26Z",
    style: {
      fill: "#571AC0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.85,254.41a5.93,5.93,0,0,1-5.42-1.82,5.81,5.81,0,0,1-1.5-5.48l13.84-52.51a5,5,0,0,1,3.92-3.65,5.94,5.94,0,0,1,5.42,1.83l39.86,42a5.82,5.82,0,0,1,1.51,5.48,5,5,0,0,1-3.92,3.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.29,206.93l3.41-.67a4.52,4.52,0,0,1,5.08,3.27L152,214.1a4.64,4.64,0,0,1,.11.51L154.28,229a3.73,3.73,0,0,1-3,4.31h0a4.5,4.5,0,0,1-4.92-2.78l-5.54-13.68a4,4,0,0,1-.17-.49l-1.26-4.58A3.76,3.76,0,0,1,142.29,206.93Zm9.65,30.28.93-.18a4,4,0,0,1,4.55,2.92h0a3.36,3.36,0,0,1-2.56,4.3l-.93.18a4,4,0,0,1-4.55-2.91h0A3.37,3.37,0,0,1,151.94,237.21Z",
    style: {
      fill: "#571AC0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrors);
export default __webpack_public_path__ + "static/media/errors.2a1a5e7c27207c63d19c63c800b77098.svg";
export { ForwardRef as ReactComponent };